const cfdLevyParcelLineItemsReport = {
  label: "CFD Levy Parcel Line Items Report",
  name: "cfdLevyParcelLineItemsReport",
  parameters: [
    {
      name: "db",
      label: "Database",
      type: "select",
      defaultValue: "cfd",
      options: [
        { key: "cfd", label: "cfd" },
        { key: "cfddev", label: "cfddev" },
        { key: "cfddev_staging", label: "cfddev_staging" },
      ],
    },
    {
      name: "districtIds",
      label: "District",
      type: "dbfield",
      table: "District",
      keyField: "DistrictId",
      valueField: "Name",
      sort: {
        Name: "asc",
      },
      multiple: true,
    },
    {
      name: "taxLienIds",
      label: "Tax Lien",
      type: "dbfield",
      table: "TaxLien",
      keyField: "TaxLienId",
      valueField: "TaxLienName",
      sort: {
        TaxLienName: "asc",
      },
      multiple: true,
    },
  ],
};

export default cfdLevyParcelLineItemsReport;
